<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <channel-state
        :channel-state="mobilePushState"
        devices
      ></channel-state>

      <v-form
        ref="form"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="mobilePush.isEnabled"
              label="Канал включён"
              hide-details
              class="mt-0"
            ></v-switch>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="mobilePush.ttlHours"
              label="Срок жизни пуша, часов"
              hint="Сколько пуш ждёт выключенный телефон"
              persistent-hint
              type="number"
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
              :error-messages="messages('ttlHours')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="mobilePush.ratePerMinute"
              label="Скорость рассылки, устройств в минуту"
              hint="Весь список разом — это волна заказов, которую кухня и колл-центр не разберут"
              persistent-hint
              type="number"
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
              :error-messages="messages('ratePerMinute')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="mobilePush.staleTokenDays"
              label="Устройство неактивно через, дней"
              hint="Через сколько дней молчания устройство считается неактивным"
              persistent-hint
              type="number"
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
              :error-messages="messages('staleTokenDays')"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              :loading="saving === 'mobilePush'"
              :disabled="hasNotPermission('Permissions.NotificationSettingsUpdate')"
              @click="saveData"
            >
              Сохранить
            </v-btn>
          </v-col>
        </v-row>
      </v-form>

      <v-divider class="my-6"></v-divider>

      <span class="text-subtitle-2">Проверка</span>
      <p class="text-caption text--secondary">
        Проверочный пуш уходит на все устройства выбранного гостя.
      </p>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <test-customer-select
            v-if="canTest"
            v-model="testCustomerId"
          ></test-customer-select>
          <span
            v-else
            class="text-caption text--secondary"
          >
            Проверочная отправка доступна с правом «Проверочная отправка пуша и SMS».
          </span>
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <v-btn
            color="primary"
            outlined
            :loading="testSending"
            :disabled="!testCustomerId || !canTest"
            @click="sendTest"
          >
            Отправить проверочный пуш
          </v-btn>
        </v-col>

        <v-col
          v-if="testResult"
          cols="12"
        >
          <v-alert
            :type="testResult.type"
            text
            dense
            class="mb-0"
          >
            {{ testResult.text }}
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'
import { errorMessages, hasPermission } from '@/helpers'
import { devicesText } from '@/helpers/notifications'
import ChannelState from '@/views/notification-settings/channel-state.vue'
import TestCustomerSelect from '@/views/notification-settings/test-customer-select.vue'

export default {
  name: 'MobilePushSettingForm',
  components: { ChannelState, TestCustomerSelect },
  data: () => ({
    rules,
    testCustomerId: null,
    testSending: false,

    testResult: null,
  }),
  computed: {
    ...mapFormHandlers('notificationSettings', [
      'mobilePush.isEnabled',
      'mobilePush.ttlHours',
      'mobilePush.ratePerMinute',
      'mobilePush.staleTokenDays',
    ]),
    ...mapState('notificationSettings', ['mobilePushState', 'saving']),
    ...mapGetters('notificationSettings', ['errorsOf']),
    canTest() {
      return hasPermission('Permissions.NotificationTestSend')
    },
  },
  methods: {
    ...mapActions('notificationSettings', ['update', 'sendTestPush']),
    hasNotPermission(value) {
      return !hasPermission(value)
    },
    messages(property) {
      return errorMessages(this.errorsOf('mobilePush'), property)
    },
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.update('mobilePush')
      }
    },
    async sendTest() {
      this.testSending = true
      this.testResult = null

      try {
        const { devices } = await this.sendTestPush(this.testCustomerId)
        this.testResult = { type: 'success', text: `Поставлено на ${devicesText(devices)}` }
      } catch (error) {
        this.testResult = {
          type: 'error',
          text: error.response?.data?.message || 'Не удалось отправить проверочный пуш',
        }
      } finally {
        this.testSending = false
      }
    },
  },
}
</script>
